import { render, staticRenderFns } from "./AppNavigationHeaderNewEvent.vue?vue&type=template&id=f0459ba8"
import script from "./AppNavigationHeaderNewEvent.vue?vue&type=script&lang=js"
export * from "./AppNavigationHeaderNewEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports